import request from '@/utils/request'
export function Device(data) {//提交考试结果
	return request({
		url:`/questionnaire/device`,
		method: 'post',
		data:data
	})
}
export function Repeated(data) {//BLOG页面分页文章
	return request({
		url:`/questionnaire/device/repeated`,
		method: 'post',
		data:new URLSearchParams(data).toString()
	})
}
